import { TrailblazerNodeType } from "./TrailblazerTypes";

/**
 * Abstract class that represents a node.
 * The TrailblazerNode is used as a data container to represent the visual data.
 */
export class TrailblazerNode {
    constructor(id, position = 0) {
        this.id = id;
        this.position = position;

        if (this.constructor === TrailblazerNode) {
            throw new Error("abstract classes can't be instantiated.");
        }
    }

    /**
     * Gets the node type as a TrailblazerNodeType enum.
     */
    // eslint-disable-next-line class-methods-use-this
    getNodeType() {
        throw new Error("method 'getNodeType()' must be implemented.");
    }
}

/**
 * A BaseNode stores data about a device.
 */
export class BaseTrailblazerNode extends TrailblazerNode {
    constructor(id, data, position) {
        super(id, position);

        if (!data) {
            throw new Error("data must be provided.");
        }
        this.type = TrailblazerNodeType.BASE;
        this.data = data;
    }

    getNodeType() {
        return this.type;
    }

    toCytoscapeElement() {
        return {
            data: {
                id: this.id,
                nodeType: this.getNodeType(),
                label: this.data.name,
                expandedLabel: this.data.toCytoscapeLabelString(),
                ...this.data.toDataObject()
            }
        };
    }
}

/**
 * A CollapsedNode stores data about a group of devices in order of route.
 */
export class CollapsedTrailblazerNode extends TrailblazerNode {
    constructor(id, collapsedNodes = [], position = 0) {
        super(id, position);
        this.type = TrailblazerNodeType.COLLAPSED;
        this.collapsedNodes = collapsedNodes; // the array order is important
    }

    getNodeType() {
        return this.type;
    }

    toCytoscapeElement() {
        return {
            data: {
                id: this.id,
                nodeType: this.getNodeType(),
                label: `${this.collapsedNodes.length}`
            }
        };
    }
}